import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import SubmitButton from '../../../../BaseModule/Components/Button/SubmitButton';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.SUBMIT_BUTTON }>;
	onSubmit: (values: object) => void;
}

const WizardSubmitButton: React.FC<Props> = ({ item, onSubmit }) => {
	const handleSubmit = (values: object) => {
		onSubmit({ ...(item.data ?? {}), ...values });
	};

	return (
		<SubmitButton
			onSubmit={handleSubmit}
			title={item.title}
			className='btn btn-submit w-100 mt-0'
		/>
	);
};

export default WizardSubmitButton;
